import { EllipsisVerticalIcon, EnvelopeIcon } from "@heroicons/react/24/outline"
import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { TextQtd } from "../../../../medias/components/tailwind/item-table/styled"
import { useHistory } from "react-router-dom"
import ModalMenuItemCode from "../../modal-menu-item-code"
import ModalUpdateCode from "../../modal-update-codes"

const ItemTableCode = (props) => {

    const [visibleModal, setVisibleModal] = useState(false)
    const dispatch = useDispatch()
    const [visibleModalMenu, setvisibleModalMenu] = useState(false)
    const [visibleModalUpdate, setVisibleModalUpdate] = useState(false)
    const history = useHistory()


    return (
        <>
            <ModalMenuItemCode setVisibleModalUpdate={setVisibleModalUpdate} goSearch={props.goSearch} item={props.item} visible={visibleModalMenu} setVisibleModal={setvisibleModalMenu} />
            <ModalUpdateCode goSearch={props.goSearch} item={props.item} visible={visibleModalUpdate} setVisible={setVisibleModalUpdate} />

            <tr key={"person.email"} className={"even:bg-gray-50"}>

                <td
                    className={props.classNames(
                        'whitespace-nowrap py-4 pr-3 text-sm font-medium',
                        " props.selectedCodes.includes(props.item)" ? 'text-gray-900' : 'text-gray-900',
                    )}
                >
                    {new Date(props.item.created_at).toLocaleDateString()}
                </td>

                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                    {props.item.serial_number}
                </td>

                <td className="whitespace-nowrap text-center px-3 py-4 text-sm text-gray-500">
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <label style={{ width: "120px", }} className={props.item.used != 1 ? "bg-green-50 text-green-700 p-2 rounded-1 flex justify-center" : "bg-red-50 text-red-700 p-2 rounded-1 flex justify-center"} >
                            {props.item.used == 1 ? "Indisponível" : "Disponível"}
                        </label>
                    </div>
                </td>

                <td className={props.classNames('whitespace-nowrap py-4 pr-3 text-sm font-medium', " props.selectedCodes.includes(props.item)" ? 'text-gray-900' : 'text-gray-900',)}                >
                    <label style={{display: "flex",textAlign: "center", justifyContent: "center"}}>
                        {props.item.data_recieved != null && new Date(props.item.data_recieved).toLocaleDateString()}
                    </label>
                </td>

                <td className="whitespace-nowrap text-center px-3 py-4 text-sm text-gray-500">
                    {props.item.license.name}
                </td>

                <td className="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-3">
                    <span style={{ position: "relative" }}>
                        <EllipsisVerticalIcon onClick={() => {
                            setvisibleModalMenu(true)
                        }} style={{ height: "32px", cursor: "pointer" }} />
                    </span>
                </td>
            </tr >
        </>

    )
}

export default ItemTableCode